import React from 'react';

const Terms = () => {
  return (
    <div className="min-h-screen">
      <section className="bg-gradient-to-br from-indigo-600 via-purple-600 to-indigo-800 text-white py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-4">Terms of Use</h1>
          <p className="text-xl text-indigo-100">Last updated: August 2025</p>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="prose prose-lg max-w-none">
          <p className="text-xl text-gray-600 mb-8">
            Please read these Terms of Use carefully before using the TECHSPR website.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-12">Acceptance of Terms</h2>
          <p className="text-gray-700 mb-8">
            By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-12">Use License</h2>
          <p className="text-gray-700 mb-4">
            Permission is granted to temporarily download one copy of the materials on TECHSPR's website for personal, non-commercial transitory viewing only.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-12">Disclaimer</h2>
          <p className="text-gray-700 mb-8">
            The materials on TECHSPR's website are provided on an 'as is' basis. TECHSPR makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-12">Limitations</h2>
          <p className="text-gray-700 mb-8">
            In no event shall TECHSPR or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on TECHSPR's website.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-12">Governing Law</h2>
          <p className="text-gray-700 mb-8">
            These terms and conditions are governed by and construed in accordance with the laws of the United States and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;